(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  const enableNekoDesktopNav = () => {
    document.querySelectorAll('.neko-nav-dropdown').forEach((dropdown) => {
      if (dropdown.dataset.hoverReady === 'true') return;

      const details = dropdown.querySelector('details');
      const summary = dropdown.querySelector('summary');
      if (!details || !summary) return;

      dropdown.dataset.hoverReady = 'true';

      dropdown.addEventListener('mouseenter', () => {
        if (!window.matchMedia('(min-width: 990px)').matches) return;
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      });

      dropdown.addEventListener('mouseleave', () => {
        if (!window.matchMedia('(min-width: 990px)').matches) return;
        if (dropdown.contains(document.activeElement)) return;
        details.open = false;
        summary.setAttribute('aria-expanded', 'false');
      });

      dropdown.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        details.open = false;
        summary.setAttribute('aria-expanded', 'false');
        summary.focus();
      });
    });
  };

  enableNekoDesktopNav();

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', enableNekoDesktopNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neko-privilege"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('neko-privilege')) {
  customElements.define('neko-privilege', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.teaser = this.querySelector('.neko-privilege-teaser');
      this.dismissed = false;
      try {
        if (performance.getEntriesByType('navigation')[0]?.type === 'reload') {
          sessionStorage.removeItem('neko-privilege-teaser-dismissed');
        }
        this.dismissed = sessionStorage.getItem('neko-privilege-teaser-dismissed') === '1';
      } catch (error) {}
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelector('[data-teaser-dismiss]').addEventListener('click', event => {
        this.dismissed = true;
        this.teaser.hidden = true;
        try { sessionStorage.setItem('neko-privilege-teaser-dismissed', '1'); } catch (error) {}
        event.currentTarget.blur();
      }, options);
      document.querySelectorAll('[data-neko-privilege-open]').forEach(button => {
        if (!this.contains(button)) button.hidden = false;
      });
      document.addEventListener('click', event => {
        const trigger = event.target.closest('[data-neko-privilege-open]');
        if (trigger) { this.trigger = trigger; this.open(); }
      }, options);
      this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      }, options);
      this.dialog.addEventListener('close', () => {
        this.teaser.hidden = this.dismissed;
        document.body.style.overflow = this.previousOverflow || '';
        if (this.trigger && this.trigger.isConnected) this.trigger.focus();
      }, options);
      const copy = this.querySelector('[data-copy]');
      if (copy) copy.addEventListener('click', async () => {
        const status = this.querySelector('.neko-privilege-copy-status');
        try {
          await navigator.clipboard.writeText(this.querySelector('[data-code]').textContent.trim());
          status.textContent = copy.dataset.copied;
          copy.textContent = copy.dataset.copied;
        } catch (error) { status.textContent = copy.dataset.error; }
      }, options);
      if (this.querySelector('[data-server-success], [data-server-error]')) {
        this.open();
      } else {
        this.teaser.hidden = this.dismissed;
      }
    }
    open() {
      this.teaser.hidden = true;
      if (!this.dialog.open) {
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
        const focus = this.querySelector('[data-server-success] h2, input[type=email]');
        if (focus) focus.focus();
      }
    }
    disconnectedCallback() {
      if (this.abort) this.abort.abort();
      if (this.dialog && this.dialog.open) document.body.style.overflow = this.previousOverflow || '';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neko-space-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('neko-space-guide')) {
    customElements.define('neko-space-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.panels = [...this.querySelectorAll('[data-copy]')];
        this.images = [...this.querySelectorAll('[data-image]')];
        this.choices = [...this.querySelectorAll('[data-select]')];
        this.play = this.querySelector('.nsg-play');
        this.copy = this.querySelector('.nsg-copy');
        this.current = 0;
        this.visible = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.playing = this.dataset.autoplay === 'true' && !this.motion.matches && !matchMedia('(max-width: 749px)').matches && !window.Shopify?.designMode;
        if (this.panels.length < 2) return;
        this.play.hidden = false;
        this.choices.forEach((button, index) => button.addEventListener('click', () => { this.pause(); this.show(index); }, options));
        this.play.addEventListener('click', () => { this.playing = !this.playing; this.updatePlay(); this.schedule(); }, options);
        this.addEventListener('focusin', event => { if (!event.target.closest('.nsg-play')) this.pause(); }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.pause(); }, options);
        this.addEventListener('shopify:block:select', event => { const panel = event.target.closest('[data-copy]'); if (panel) { this.pause(); this.show(Number(panel.dataset.copy)); } }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: .2 });
        this.observer.observe(this);
        this.updatePlay();
      }
      disconnectedCallback() { clearTimeout(this.timer); this.observer?.disconnect(); this.controller?.abort(); this.initialized = false; }
      pause() { this.playing = false; this.updatePlay(); this.schedule(); }
      updatePlay() { this.play.setAttribute('aria-label', this.playing ? this.dataset.pause : this.dataset.play); this.play.firstElementChild.textContent = this.playing ? 'Ⅱ' : '▶'; this.copy.setAttribute('aria-live', this.playing ? 'off' : 'polite'); }
      schedule() { clearTimeout(this.timer); if (this.playing && this.visible && !document.hidden) this.timer = setTimeout(() => { this.show((this.current + 1) % this.panels.length); this.schedule(); }, Number(this.dataset.delay) || 6500); }
      show(index) {
        if (index === this.current || !this.panels[index]) return;
        this.images[this.current].classList.add('is-leaving');
        this.current = index;
        this.panels.forEach((panel, i) => { panel.hidden = i !== index; panel.classList.toggle('is-active', i === index); panel.classList.remove('is-entering'); });
        this.images.forEach((image, i) => { image.classList.toggle('is-active', i === index); image.setAttribute('aria-hidden', String(i !== index)); if (i === index) image.classList.remove('is-leaving'); });
        this.choices.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        void this.panels[index].offsetWidth;
        this.panels[index].classList.add('is-entering');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
